(() => {
  function initSection(section) {
    const toggles = Array.from(section.querySelectorAll("[data-two-toggle]"));
    const slide1 = section.querySelector(".slide-1");
    const slide2 = section.querySelector(".slide-2");

    const setSlide = (n) => {
      const target = n === 2 ? 2 : 1;
      section.dataset.currentSlide = String(target);
      if (target === 2) {
        section.classList.add("is-slide-2");
        slide1 && slide1.setAttribute("aria-hidden", "true");
        slide2 && slide2.setAttribute("aria-hidden", "false");
        if (toggles.length)
          toggles.forEach((t) => {
            t.checked = true;
          });
      } else {
        section.classList.remove("is-slide-2");
        slide1 && slide1.setAttribute("aria-hidden", "false");
        slide2 && slide2.setAttribute("aria-hidden", "true");
        if (toggles.length)
          toggles.forEach((t) => {
            t.checked = false;
          });
      }
    };

    // Initialize
    setSlide(1);

    // Toggle handler
    if (toggles.length) {
      toggles.forEach((t) => {
        t.addEventListener("change", () => {
          setSlide(t.checked ? 2 : 1);
        });
      });
    }

    // Keyboard navigation
    section.addEventListener("keydown", (e) => {
      if (e.key === "ArrowRight") {
        setSlide(2);
      } else if (e.key === "ArrowLeft") {
        setSlide(1);
      }
    });

    // Swipe navigation
    let touchStartX = null;
    let touchStartY = null;
    const threshold = 30;
    section.addEventListener(
      "touchstart",
      (e) => {
        const t = e.changedTouches[0];
        touchStartX = t.clientX;
        touchStartY = t.clientY;
      },
      { passive: true },
    );
    section.addEventListener(
      "touchend",
      (e) => {
        if (touchStartX == null || touchStartY == null) return;
        const t = e.changedTouches[0];
        const dx = t.clientX - touchStartX;
        const dy = t.clientY - touchStartY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > threshold) {
          if (dx < 0) {
            setSlide(2);
          } else {
            setSlide(1);
          }
        }
        touchStartX = null;
        touchStartY = null;
      },
      { passive: true },
    );

    // Marquee speed binding
    const marquee = section.querySelector(".s1-marquee");
    if (marquee) {
      const speed = Number(marquee.getAttribute("data-speed") || 5);
      // Map 1..10 to 30s..8s duration (faster when higher)
      const duration = Math.max(8, 30 - (speed - 1) * 2.444);
      const track = marquee.querySelector(".marquee-track");
      if (track) {
        track.style.animationDuration = `${duration}s`;
      }
    }

    // Hover-to-play videos in Slide 2 grid
    const tiles = section.querySelectorAll(".s2-item");
    tiles.forEach((tile) => {
      const video = tile.querySelector("video.s2-video");
      if (!video) return;
      const ensureSrc = () => {
        if (!video.getAttribute("src") && video.dataset.videoSrc) {
          video.setAttribute("src", video.dataset.videoSrc);
          video.load();
        }
      };
      const playVideo = () => {
        ensureSrc();
        video.style.opacity = "1";
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(() => {});
        }
      };
      const pauseVideo = () => {
        video.pause();
        video.style.opacity = "0";
      };
      tile.addEventListener("mouseenter", playVideo);
      tile.addEventListener("mouseleave", pauseVideo);
      tile.addEventListener("focusin", playVideo);
      tile.addEventListener("focusout", pauseVideo);

      // On touch devices, tap to toggle play state
      tile.addEventListener(
        "touchend",
        (e) => {
          // prevent following the link immediately
          if (!video.getAttribute("src")) {
            e.preventDefault();
            ensureSrc();
            video.style.opacity = "1";
            video.play().catch(() => {});
            // next tap will follow the link
          }
        },
        { passive: false },
      );
    });
  }

  function initAll() {
    document
      .querySelectorAll(".two-slide-toggle-carousel")
      .forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
